export default __webpack_public_path__ + "static/corcoran-logo-377a785886b77cf13a27d2fe60b9fba1.svg";